/* eslint-disable import/prefer-default-export */
import apiClient from '../utilities/api-client';

export const searchQuestions = async (text) => apiClient.get(`/questions?search=${text}`);
